/* eslint-disable flowtype/require-valid-file-annotation */
/* eslint-disable react/no-multi-comp */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from 'material-ui/styles';
import keycode from 'keycode';
import Table, { TableBody, TableCell, TableFooter, TablePagination, TableRow } from 'material-ui/Table';
import Checkbox from 'material-ui/Checkbox';
import Paper from 'material-ui/Paper';
import Button from 'material-ui/Button';
import classnames from 'classnames';
import { debounce } from 'lodash';
import SortableTableHead from './SortableTableHead';
import SearchField from './SearchField';
import * as InspectionActions from '../../../inspection/inspection.actions';
import * as ReportsActions from '../../../reports/reports.actions';
import { getAvailableFilters } from '../../../inspection/inspection.selectors';
import {
  getCurrentPage,
  getUnfilteredData,
  getFormDataFromPage,
  getReportsPerPage,
  getSelections,
  getSortingTerm,
  getFilteredDataCount,
} from '../../../reports/reports.selectors';
import { getCurrentUserRole } from '../../../user/user.selectors';
import RemoveReportsConfirm from '../../../reports/components/RemoveReportsConfirm';
import WorkorderConfirm from '../../../reports/components/WorkorderConfirm';
import WorkorderInfo from '../../../reports/components/WorkorderInfo';
import PrintReportsConfirm from '../../../reports/components/PrintReportsConfirm';
import XlsxReportsConfirm from '../../../reports/components/XlsxReportsConfirm';
import { statusToString } from '../../../../utils/user-utils';
import each from 'lodash/each';
import { UserRoles } from '../../../user/user.constants';
import Loading from '../../../core/components/Loading';
import Filters from './Filters';
import AssignmentTurnedInIcon from 'material-ui-icons/AssignmentTurnedIn';

import styles from './styles';

// Timeout in ms for debouncing server requests when user triggers an event multiple times.
// Using debounce allows to not overload server and provide better UX. 
const DEBOUNCE_TIMEOUT_MS = 600;

class SortableTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      removeReportsOpen: false,
      printReportsOpen: false,
      xlsxOpen: false,
      workorderInfo: {},
    };
  }

  handleRequestSort = (event, property) => {
    const { setReportsSort, readInspections } = this.props;
    setReportsSort(property);
    readInspections();
  };

  handleSelectAllClick = (event, checked) => {
    const { toggleReportSelectAll, array } = this.props;
    let ids = [];
    if (checked) {
      ids = array.map(n => n._id);
    }
    toggleReportSelectAll(ids);
  };

  selectionClick = (event, id) => {
    const { toggleReportSelection } = this.props;
    toggleReportSelection(id);
  };

  handleKeyDown = (event, id) => {
    if (keycode(event) === 'space') {
      this.selectionClick(event, id);
    }
  };

  handleClick = (event, id, status) => {
    if (status === 'completed') this.props.history.push(`/inspection/view/${id}/raportti`);
    else this.props.history.push(`/inspection/edit/${id}/perustiedot`);
  };

  handleChangePage = (event, page) => {
    const { setReportsPage, readInspections } = this.props;
    setReportsPage(page);
    readInspections();
  };

  handleChangeRowsPerPage = event => {
    const { setReportsPerPage, readInspections } = this.props;
    setReportsPerPage(event.target.value);
    readInspections();
  };

  handleDelete = () => {
    this.setState({ removeReportsOpen: true });
  };

  handleDeleteClosed = () => {
    this.setState({ removeReportsOpen: false });
  };

  handleFiltersChanged = (event, index, fieldName) => {
    const { availableFilters, setReportsFilter, readInspections } = this.props;
    let filter = { value: event.target.value };
    if ((fieldName === 'yearModel' || fieldName === 'hoursUsed') && filter.value !== 'all') {
      filter = {
        ...filter,
        ...Object.values(availableFilters[fieldName]).find(item => {
          return item.label === filter.value;
        }),
      };
    }
    setReportsFilter(filter, fieldName);
    readInspections();

  };

  handleWorkorder = () => {
    const serials = this.getWorkorderSerialnumbers()
    this.setState({ sendWorkorderOpen: true, selectedSerialnumbers: serials});
  };

  getWorkorderSerialnumbers = () => {
    const {pageReportData, selections} = this.props
    const reportData = []

    selections.forEach((id) => {
      if(pageReportData[id]) reportData.push(pageReportData[id])
    })

    if(reportData.length){
      let serialnumbers = [];
      reportData.forEach(formData => {
        if(formData){
          const serialnum = (formData.perustiedot && formData.perustiedot.fieldset && formData.perustiedot.fieldset.sarjanumero) || null
          if(serialnum) serialnumbers.push(serialnum)
        }
      });
      return serialnumbers;
    }else{
      return [];
    }
  }

  handleWorkorderClosed = () => {
    this.setState({ sendWorkorderOpen: false });
  };

  handleWorkorderInfo = (evant, id, wo) => {
    if(wo){
      const {pageReportData} = this.props
      const reportData = pageReportData[id]
      const sarjanumero = reportData && reportData.perustiedot && reportData.perustiedot.fieldset && reportData.perustiedot.fieldset.sarjanumero
      const date = new Date(wo.sentAt)
      const workorderDate = date.getDate()+'.'+date.getMonth()+'.'+date.getFullYear()+'  Kello '+(date.getHours() < 10 ? '0' : '') + date.getHours()+':'+(date.getMinutes() < 10 ? '0' : '') + date.getMinutes()

      const workorderInfo={
        sentAt: workorderDate || null,
        serialnumber: sarjanumero || null,
      }
      this.setState({ sendWorkorderInfoOpen: true, workorderInfo: workorderInfo });
    }
  };

  handleWorkorderInfoClosed = () => {
    this.setState({ sendWorkorderInfoOpen: false });
  };

  handlePrint = () => {
    this.setState({ printReportsOpen: true });
  };

  handlePrintClosed = () => {
    this.setState({ printReportsOpen: false });
  };

  handleXlsx = () => {
    this.setState({ xlsxOpen: true });
  };

  handleXlsxClosed = () => {
    this.setState({ xlsxOpen: false });
  };

  toggleShowUnfinishedChanged = (event, checked) => {
    const { setReportsFilter, readInspections } = this.props;
    if (checked) {
      setReportsFilter({ value: 'completed', reverse: true }, 'status');
    } else {
      setReportsFilter({ value: 'all' }, 'status');
    }
    readInspections();
  };

  unFinishedChecked() {
    let checked = false;
    each(this.props.filters, function (filter) {
      if (filter.field === 'status') {
        checked = filter.value.value === 'completed';
      }
    });
    return checked;
  }

  debouncedReadInspections = debounce(() => {
    this.props.readInspections();
  }, DEBOUNCE_TIMEOUT_MS);

  handleSearchChanged = event => {
    const { setReportsSearch } = this.props;
    setReportsSearch(event.target.value);

    // Use debounced version so that we do not request
    // inspections for every changed character.
    this.debouncedReadInspections();
  };

  isRowSelected = id => this.props.selections.indexOf(id) !== -1;

  shouldHighLightRow(row) {
    switch (row) {
      case 'pending':
      case 'waitingForPricing':
      case 'waitingForInspectorPricing':
      case 'waitingForDepartmentPricing':
      case 'new':
        return true;
      default:
        return false;
    }
  }

  handleRefresh = event => {
    const { readInspections } = this.props;
    readInspections();
  };

  render() {
    const {
      availableFilters,
      classes,
      columns,
      selections,
      array,
      rowsPerPage,
      sortingTerm,
      page,
      filteredCount,
      online,
      role,
      isFetching,
      pageReportData
    } = this.props;
    const { column, direction } = sortingTerm;
    const isAnyRowSelected = selections.length > 0;
    const isGuest = role === UserRoles.GUEST;

    return (
      <Paper className={classes.root}>
        <SearchField onSearchChange={this.handleSearchChanged} />
        {isFetching && (
          <div className={classes.loader}>
            <Loading />
          </div>
        )}
        <Filters
          columns={columns}
          availableFilters={availableFilters}
          handleFiltersChanged={this.handleFiltersChanged}
        />
        <div className={classes.tableWrapper}>
          <Table>
            <SortableTableHead
              columns={columns}
              className={classes.tableHead}
              numSelected={selections.length}
              order={direction}
              orderBy={column}
              onSelectAllClick={this.handleSelectAllClick}
              onRequestSort={this.handleRequestSort}
              rowCount={array.length}
              refresh={this.handleRefresh}
            />
            <TableBody className={classes.tableBody}>
              {array.map((n, index) => {
                const isRowSelected = this.isRowSelected(n._id);
                const statusClass = classnames([classes.tableCell, classes.tableCellLast], {
                  [classes.pending]: this.shouldHighLightRow(n.status),
                });
                const createdBy = n.createdBy ? n.createdBy.firstName + ' ' + n.createdBy.lastName : '';

                const serialNum = ((((pageReportData[n._id] || {}).perustiedot || {}).fieldset || {}).sarjanumero || null)

                return (
                  <TableRow
                    hover
                    onKeyDown={event => this.handleKeyDown(event, n._id)}
                    role="checkbox"
                    aria-checked={isRowSelected}
                    tabIndex={-1}
                    key={n._id ? n._id : index}
                    selected={isRowSelected}
                  >
                    <TableCell onClick={event => this.selectionClick(event, n._id)} padding="checkbox">
                      <Checkbox checked={isRowSelected} />
                    </TableCell>
                    <TableCell onClick={event => this.handleClick(event, n._id, n.status)} padding="none">
                      {n.identifier}
                    </TableCell>
                    <TableCell
                      onClick={event => this.handleClick(event, n._id, n.status)}
                      className={classes.tableCell}
                    >
                      {n.section}
                    </TableCell>
                    <TableCell
                      onClick={event => this.handleClick(event, n._id, n.status)}
                      className={classes.tableCell}
                    >
                      {n.brand}
                    </TableCell>
                    <TableCell
                      onClick={event => this.handleClick(event, n._id, n.status)}
                      className={classes.tableCell}
                    >
                      {n.model}
                    </TableCell>
                    <TableCell
                      onClick={event => this.handleClick(event, n._id, n.status)}
                      className={classes.tableCell}
                      numeric
                    >
                      {serialNum}
                    </TableCell>
                    <TableCell
                      onClick={event => this.handleClick(event, n._id, n.status)}
                      className={classes.tableCell}
                      numeric
                    >
                      {n.hoursUsed}
                    </TableCell>
                    <TableCell
                      onClick={event => this.handleClick(event, n._id, n.status)}
                      className={classes.tableCell}
                    >
                      {n.client}
                    </TableCell>
                    <TableCell
                      onClick={event => this.handleClick(event, n._id, n.status)}
                      className={classes.tableCell}
                    >
                      {createdBy}
                    </TableCell>
                    <TableCell onClick={event => this.handleClick(event, n._id, n.status)} className={statusClass}>
                      {statusToString(n.status)}
                    </TableCell>
                    <TableCell onClick={event => this.handleWorkorderInfo(event, n._id, n.workordersent)} className={classes.tableCell}>
                      {n.workordersent && <AssignmentTurnedInIcon className={classes.iconInTable}/>}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
            <TableFooter>
              <TableRow>
                {filteredCount >= 5 && (
                  <TablePagination
                    count={filteredCount}
                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
                    labelRowsPerPage="Näytetään tuloksia per sivu:"
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                )}
              </TableRow>
            </TableFooter>
          </Table>
        </div>
        <footer className={classes.footer}>
          {!isGuest && (
            <Button color="accent" onClick={this.handleDelete} disabled={!isAnyRowSelected || !online}>
              Poista
            </Button>
          )}
          <Button color="accent" onClick={this.handleWorkorder} disabled={!isAnyRowSelected || !online}>
            Lähetä työtilaus
          </Button>
          <Button color="accent" onClick={this.handlePrint} disabled={!isAnyRowSelected || !online}>
            Tulosta valitut
          </Button>
          <Button color="accent" onClick={this.handleXlsx} disabled={!isAnyRowSelected || !online}>
            Vie Exceliin
          </Button>
        </footer>
        <RemoveReportsConfirm
          reports={selections}
          open={this.state.removeReportsOpen}
          onRequestClose={this.handleDeleteClosed}
        />
        <WorkorderConfirm
          reports={selections}
          workorderSerialnumbers={this.state.selectedSerialnumbers}
          open={this.state.sendWorkorderOpen}
          onRequestClose={this.handleWorkorderClosed}
        />
        <WorkorderInfo
          workorderInfo={this.state.workorderInfo}
          open={this.state.sendWorkorderInfoOpen}
          onRequestClose={this.handleWorkorderInfoClosed}
        />
        <PrintReportsConfirm
          reports={selections}
          open={this.state.printReportsOpen}
          onRequestClose={this.handlePrintClosed}
        />
        <XlsxReportsConfirm
          reports={selections}
          open={this.state.xlsxOpen}
          onRequestClose={this.handleXlsxClosed}
        />
      </Paper>
    );
  }
}

SortableTable.defaultProps = {
  availableFilters: [],
};

const mapStateToProps = state => {
  const array = getUnfilteredData(state); // array includes only the current pages report data = 25 entries by default!
  const pageReportData = getFormDataFromPage(state)
  const availableFilters = getAvailableFilters(state);
  const selections = getSelections(state);
  const rowsPerPage = getReportsPerPage(state);
  const sortingTerm = getSortingTerm(state);
  const page = getCurrentPage(state);
  const filteredCount = getFilteredDataCount(state);
  const online = state.offline.online;
  const role = getCurrentUserRole(state);
  const isFetching = state.entities.inspection.isFetching;

  return {
    array,
    pageReportData,
    availableFilters,
    selections,
    rowsPerPage,
    sortingTerm,
    page,
    filteredCount,
    online,
    role,
    isFetching,
  };
};

export default connect(mapStateToProps, Object.assign({}, InspectionActions, ReportsActions))(
  withRouter(withStyles(styles)(SortableTable))
);



// WEBPACK FOOTER //
// ./src/modules/common/components/table/SortableTable.js